


import http from "./http_common";

class demoServices {
  saveDemoEnquiry(data) {
    return http.post("/DemoEnquiry/save", data);
  };
}

export default new demoServices();